import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryDirectoryFetchFailedAction = {
	type: 'BENEFICIARY_DIRECTORY_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryDirectoryFetchFailedAction => ({
	type: 'BENEFICIARY_DIRECTORY_FETCH_FAILED',
	payload,
});
